module.exports = __webpack_public_path__ + "static/media/image_flip.bfd323f2.png";